/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap px-5'>
          {/* begin::Links */}
          {/*<div className='d-flex fw-semibold text-primary fs-base'>*/}
          {/*  <a href='#' className='px-5' target='_blank'>*/}
          {/*    Terms*/}
          {/*  </a>*/}

          {/*  <a href='#' className='px-5' target='_blank'>*/}
          {/*    Plans*/}
          {/*  </a>*/}

          {/*  <a href='#' className='px-5' target='_blank'>*/}
          {/*    Contact Us*/}
          {/*  </a>*/}
          {/*</div>*/}
          {/* end::Links */}
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      {/* <div
        className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        // style={{backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-screens.png')})`}}
        //  style={{backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})`}}
      > */}
      
    <div
      className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
//    style={{
//   background: `
//     radial-gradient(circle at 20% 25%, rgba(255,255,255,0.08), transparent 60%),
//     radial-gradient(circle at 80% 20%, rgba(255,255,255,0.06), transparent 60%),
//     radial-gradient(circle at 25% 80%, rgba(255,255,255,0.07), transparent 60%),
//     radial-gradient(circle at 75% 75%, rgba(255,255,255,0.06), transparent 60%),
//     linear-gradient(to bottom, #009ef7, #009eff, #80caff)
//   `,
//   backgroundRepeat: "no-repeat",
//   backgroundSize: "cover",
// }}

      // style={{
      //   background: `
      //     /* Wave layer 1 - large, light wave */
      //     radial-gradient(circle at 20% 40%, rgba(255, 255, 255, 0.15), transparent 60%),
      //     /* Wave layer 2 - medium wave with shadow */
      //     radial-gradient(circle at 70% 60%, rgba(0, 0, 0, 0.12), transparent 70%),
      //     /* Wave layer 3 - smaller wave highlight */
      //     radial-gradient(circle at 50% 80%, rgba(255, 255, 255, 0.1), transparent 75%),
      //     /* Base blue gradient */
      //     linear-gradient(to bottom, #009ef7, #009eff, #80caff)
      //   `,
      //   backgroundBlendMode: "overlay",
      //   backgroundRepeat: "no-repeat",
      //   backgroundSize: "cover",
      // }}

     style={{
       backgroundColor:"#1e1e2d"
     }}

  //    style={{
  //   height: "100vh",
  //   width: "100%",
  //   background: `linear-gradient(
  //     145deg, 
  //     #1e1e2d,       /* base dark color */
  //     #2a2a3d,       /* slightly lighter for depth */
  //     #151521        /* slightly darker for shadow */
  //   )`,
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   color: "#fff"
  // }}
        >
        <div
      // style={{
      //   position: "absolute",
      //   inset: 0,
      //   background: "#009ef7",
      //   opacity: 0.4,   // adjust tint strength
      // }}
    />

        {/* begin::Content */}
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          {/* begin::Logo */}
          <span  className='mb-12'>
            {/* <img alt='Logo' src={toAbsoluteUrl('/media/logos/auth-screens-backup.png')} className='h-75px' /> */}        
         <img
          alt='Logo'
          // src='	https://www.caglobal.com/cdn/shop/files/C_A_Logo_1.svg?v=1689244845&width=280'
          src={toAbsoluteUrl('/uploads/logo/CAGlobalLOGO.png')}
          className='h-75px'
        />
          </span>
          {/* end::Logo */}

          {/* begin::Image */}
           <img
            className='mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20'
            // src={toAbsoluteUrl('/media/misc/auth-screens.png')}
            src={toAbsoluteUrl('/media/misc/auth-screens-backup.png')}
            // src={toAbsoluteUrl('/media/misc/vector-mar-2021-50_generated.jpg')}
            alt='' 
          /> 
          {/* end::Image */}

          {/* begin::Title */}
          <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
            ProfitPricingTool
           </h1>
          {/* end::Title */}

          {/* begin::Text */}
          {/*<div className='text-white fs-base text-center'>*/}
          {/*  In this kind of post,{' '}*/}
          {/*  <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>*/}
          {/*    the blogger*/}
          {/*  </a>*/}
          {/*  introduces a person they’ve interviewed <br /> and provides some background information*/}
          {/*  about*/}
          {/*  <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>*/}
          {/*    the interviewee*/}
          {/*  </a>*/}
          {/*  and their <br /> work following this is a transcript of the interview.*/}
          {/*</div>*/}
          {/* end::Text */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div>
  )
}

export {AuthLayout}
